import { request } from '../core/request';

interface MutationLoginData {
  code: string;
}

interface MutationLoginResponse {
  accessToken: string;
  expiresIn: string;
  idToken: string;
  refreshToken: string;
  scope: string;
  tokenType: string;
  expAt: string;
}

const REDIRECT_URI = import.meta.env.VITE_APP_REDIRECT_URI;

export default (data: MutationLoginData) => {
  return request<MutationLoginResponse>('/get-sso-token', {
    method: 'POST',
    baseURL: 'common',
    data: {
      code: data.code,
      redirectUri: REDIRECT_URI,
      jobType: 1, // 外勤（前台）
    },
  });
};
